/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Skeleton,
} from "@chakra-ui/react";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { css } from "@emotion/react";
import { MdClose } from "react-icons/md";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  .subtitle {
    font-size: 18px;
    font-weight: 600;
    line-height: 23px;

    margin-bottom: 12px;
  }

  .text {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  margin-top: 5px;

  img {
    margin-right: 16px;
  }
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;

  padding: 8px;

  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    color: #868482;
  }
`;

interface SetupFeeProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SetupFee({ isOpen, onClose }: SetupFeeProps) {
  return (
    <Modal motionPreset="scale" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay zIndex="999999999999" />
      <div style={{ zIndex: 999999999999, position: "fixed" }}>
        <ModalContent
          css={css`
            z-index: 999999999999 !important;
          `}
          marginTop="5%"
          maxWidth="840px"
          width="calc(100% - 16px)"
          pt="24px"
          pb="48px"
          position="relative"
        >
          <ModalHeader
            fontSize="20px"
            fontWeight="600"
            display="flex"
            alignItems="center"
            justifyContent="start"
            gridGap="8px"
            px={["24px", "40px", "56px", "72px"]}
          >
            <AiOutlineQuestionCircle
              width="20px"
              height="20px"
              color="#FB972E"
            />{" "}
            What does the set up fee cover?
          </ModalHeader>

          <CloseButtonWrapper onClick={onClose}>
            <MdClose />
          </CloseButtonWrapper>

          <ModalBody px={["24px", "40px", "56px", "72px"]}>
            <Content>
              <Flex>
                <div className="text-wrapper">
                  <div className="text">
                    As part of your one-time set-up fee, BerserkerMail not only
                    migrates your business’ list for you if you choose, but also
                    scrubs your list sparkling clean via (1) first running it
                    against a database of almost 200,000 known bogus domains
                    used by bots, spammers, and other delivery-killers… and then
                    (2) “laundering” it through one of the single most advanced
                    list scrubbing technologies ever invented — wiping it
                    spotless of bots, spam traps, honey pot addresses that are
                    scraped & harvested by spammers, spam button pushers, as
                    well as undeliverable email addresses, malformed email
                    addresses, & abandoned email addresses seized by ISPs to
                    “spy” on email marketers. (NOTE: BerserkerMail’s owners will
                    not allow a “dirty” list on their platform. If you want to
                    use a filthy list you rented or built that is full of fake,
                    bot-run, or malicious email addresses, your business will be
                    barred from the platform.)
                  </div>
                </div>
              </Flex>
            </Content>
          </ModalBody>
        </ModalContent>
      </div>
    </Modal>
  );
}
